import {ref} from 'vue';

export function useToggle(value = false) {
  const toggleValue = ref(value);

  function onToggle() {
    toggleValue.value = !toggleValue.value;
  }

  return {
    toggleValue,
    onToggle,
  };
}
